<div class="login">
    <div class="parent">
        <div class="login-logo">
            <div class=" login_img">
                <img [src]="appConfigService.config.branding.favicon">
            </div>
        </div>
    </div>
</div>

<div class="row justify-content-center no_margin">
    <div class="col-lg-6 col-md-3 col-sm-10 col-xs-6 form_group1">
        <form class="kt-form" autocomplete="off" [formGroup]="enterOTPForm">
            <h5 class="label-form">Enter Your verfication code</h5>
            <div class="kt-form_label">
                <label>We send a code to <span>{{email}}</span></label>
            </div>

            <div class="row middle_center">
                <div class="col-6">
                    <div class="row middle_center ">
                        <mat-form-field class="col-2">
                            <input #digitOne matInput type="text" maxlength="1" id="otp1" placeholder=""
                                formControlName="otp1" (keyup)="keytab1($event, 1)" (click)="focusElement(digitTwo)">
                            <mat-error id="error_otp1_required"
                                *ngIf="hasError(enterOTPForm,'otp1', 'required')"></mat-error>
                            <mat-error id="error_otp1_max_length" *ngIf="hasError(enterOTPForm,'otp1', 'maxlength')">
                                have more char 1
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="col-2">
                            <input #digitTwo matInput type="text" maxlength="1" id="otp2" placeholder=""
                                formControlName="otp2" (keyup)="keytab2($event, 1)" (click)="focusElement(digitThree)">
                            <mat-error id="error_otp2_required"
                                *ngIf="hasError(enterOTPForm,'otp2', 'required')"></mat-error>
                            <mat-error id="error_otp2_max_length" *ngIf="hasError(enterOTPForm,'otp2', 'maxlength')">
                                have more char 1
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="col-2">
                            <input #digitThree matInput type="text" maxlength="1" id="otp3" placeholder=""
                                formControlName="otp3" (keyup)="keytab3($event, 1)" (click)="focusElement(digitFour)">
                            <mat-error id="error_otp3_required"
                                *ngIf="hasError(enterOTPForm,'otp3', 'required')"></mat-error>
                            <mat-error id="error_otp3_max_length" *ngIf="hasError(enterOTPForm,'otp3', 'maxlength')">
                                have more char 1
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="col-2">
                            <input #digitFour matInput type="text" maxlength="1" id="otp4" placeholder=""
                                formControlName="otp4"  >
                            <mat-error id="error_otp4_required"
                                *ngIf="hasError(enterOTPForm,'otp4', 'required')"></mat-error>
                            <mat-error id="error_otp4_max_length" *ngIf="hasError(enterOTPForm,'otp4', 'maxlength')">
                                have more char 1
                            </mat-error>
                        </mat-form-field>

                        <!-- <mat-form-field class="col-2">
                            <input #digitFive matInput type="text" maxlength="1" id="otp5" placeholder=""
                                formControlName="otp5" (keyup)="keytab5($event, 1)">
                            <mat-error id="error_otp5_required"
                                *ngIf="hasError(enterOTPForm,'otp5', 'required')"></mat-error>
                            <mat-error id="error_otp5_max_length" *ngIf="hasError(enterOTPForm,'otp5', 'maxlength')">
                                have more char 1
                            </mat-error>
                        </mat-form-field> -->
                    </div>
                </div>
                <div class="kt-login__actions row justify-content-center">
                    <button id="login" class="btn primary_large_btn" (click)="verifyOTP()"
                        [disabled]="!enterOTPForm.valid">Verify</button>
                    <span class="forgetPassword d-flex justify-content-center my-2">
                        <a id="link_forget_password" class="forgetPassword" routerLinkActive="active"
                            [routerLink]="['/authentication/login']">
                            Cancel
                        </a>
                    </span>
                    <div class="resend_code">
                        <span>Didn't get any code? <br>
                            Resend it <span *ngIf="seconds > 0"> in <span class="counter">{{seconds}}</span></span>
                        </span>
                        <button class="btn primary_large_btn" [disabled]="seconds > 0" (click)="generateUserOTP()"
                            type="button">resend?</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>